export const courseRoutes = [
  {
    path: "/course/:id",
    name: "CoursePage",
    props: true,
    component: () => import("./views/CourseStart.vue"),
  },
  {
    path: "/course/:id/play",
    name: "ScormPlayer",
    props: true,
    component: () => import("./views/ScormPlayer.vue"),
  },
  {
    path: "/flex/:id",
    name: "FlexStart",
    component: () => import("@/course/views/FlexStart.vue"),
    props: true,
  },
];
